module.exports = __webpack_public_path__ + "img/occupied1.dde74f7b.svg";